module.exports = __webpack_public_path__ + "assets/img/password.ec0c7ae5.svg";